
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Line, mixins } from 'vue-chartjs';
import { generateBasicLine, BasicLineConfig, BasicLineSetting } from './basic-line';
import {
  _isEmpty,
} from '@samclick-lodash';

enum LineChartType {
    BASIC_LINE = 'BASIC_LINE',
}

@Component({
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
})
class LineChart extends Vue<Line> {
    @Watch('$props.data', { immediate: true })
  dataWatcher(newVal: string, oldVal: string) {
    if (!_isEmpty(newVal)) {
      this.renderLineChart();
    } else if (_isEmpty(newVal) && this._data && this._data._chart) {
      this._data._chart.destroy();
    }
  }

    @Watch('$i18n.i18nLoadedAt')
    watchConfig(newVal: string, oldVal: string) {
      this.renderLineChart();
    }

    renderLineChart() {
      const self = this;
      let chartDetail = { labels: [], datasets: [] };
      if (this.$props.type === LineChartType.BASIC_LINE) {
        chartDetail = generateBasicLine(this.$props.config, this.$props.data, this.$props);
      }
      this.$nextTick(() => {
        self.renderChart(chartDetail.chartData, chartDetail.chartOptions);
      });
    }

    mounted() {
      this.renderLineChart();
    }
}

export { LineChartType, BasicLineConfig, BasicLineSetting };
export default LineChart;
